/**
 * Centralized API Endpoints for sxeang project
 * All API URLs should be defined here to maintain consistency across all components
 */

export const API_ENDPOINTS = {
  // Bulk Enrollment APIs
  BULK_ENROLLMENT: {
    DOWNLOAD: '/sxesvc/api/v3/bulk-enrollment/download',
    SUBMITTED_APPS: '/sxesvc/api/v3/bulk-enrollment/submittedApps',
    UPLOAD: '/sxesvc/api/v3/bulk-enrollment/upload'
  },

  // Retail Application APIs
  RETAIL_APP: {
    INFO: '/sxesvc/api/v3/retailapp/info',
    SEARCH: '/sxesvc/api/v3/retailapp/retailAppSearch'
  },

  // Secure Application APIs
  SECURE_APP: {
    ICM: '/sales-secure/v1/secure/icm',
    HEALTHSHARPA: '/sales-secure/v1/secure/healthsherpa/sp'
  },

  //CMOD end points
  CMOD: {
    GET_DOCUMENTS: '/sales/v1/ext/get-document'
  },

  ENROLLMENT: {
    SEP_ENROLLMENT_RULE: '/sales-portal-services/v1/sep-life-events/enrollmentRules',
    INDIVIDUAL_RENEWAL: '/sales-portal-services/v1/individual-renewals/search'
  },

  EBILL: {
    SSO_URL: '/sales/v2/ext/ebill/ebillPayment/transfer'
  },

  DOCUMENT_INFO: {
    BENIFIT_GRID: '/sxesvc/api/v1/product/sg/benefitguide',
    NAS_SBC_DOC_SEARCH: '/cmcrst/v1/sbc/documents',
    NAS_SBC_DOC_RETRIEVAL: '/cmcrst/v1/sbc/file'
  },

  REPORTS: {
    MEDICARE_SUPPLIMENT: '/sales-portal-services/v1/medicare-supplement/generatePDF',
    MN_ENROLLMENT_STATUS: '/cmcsnr/v1/mnenrollmentreport/getMNEnrollmentReport',
    AGENCY_FETCH_CONFIGURATION: '/cmcrst/report/api/v1/agencyReports/fetchConfiguration',
    AGENCY_CREATE_REPORT: '/cmcrst/report/api/v1/agencyReports/createReport',
    AGENCY_FETCH_REPORT: '/cmcrst/report/api/v1/agencyReports/fetchReports',
    AGENCY_DOWNLOAD_REPORT: '/cmcrst/v1/agencyReports/downloadReport',
    PROVIDER_DIRECTORY_REPORT: '/cmcsnr/v1/providerDirectory/report'
  },

  INDIVIDUAL_NEW_BUSINESS: {
    SEND_REFERRAL: '/cmcrst/v1/linkSharing/application'
  },

  EMAIL_SERVICES: {
    APP_CONFIRMATION_EMAIL: '/cmcsnr/v1/emailService/applicationConfirmationEmail',
    SEND_EMAIL_EXACTTARGET: '/cmcrst/v1/exactTarget'
  }
};